import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import PDFDocument from "./natvepdf";
import { saveAs } from "file-saver";
import { Backdrop, CircularProgress } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFile,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import { PDFDownloadLink } from "@react-pdf/renderer";
import OnboardPDF from "./natvepdf";

const Accordion = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="mb-4"
      style={{
        borderRadius: "12px",
        border:
          "var(--stroke-weight-1, 1px) solid var(--color-grey-96, #F3F4F6)",
        background: "var(--color-white-02, rgba(255, 255, 255, 0.00))",
        boxShadow: "0 0 2px 0 rgba(0, 0, 0, 0.26)",
      }}
    >
      <button
        style={{
          outline: isOpen ? "none" : undefined,
        }}
        className="flex justify-between items-center w-full p-4 text-lg font-semibold"
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
        <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
      </button>
      {isOpen && <div className="p-4 border-t">{children}</div>}
    </div>
  );
};

const OnBoardView = ({ ismodal, setIsModal, data }) => {
  const [loading, setLoading] = useState(false);
  const [bigImage, setBigImage] = useState(null);
  if (!ismodal || !data) return null;

  const parseForm = (form) => {
    // try {
    //   return form ? JSON.parse(form) : null;
    // } catch {
    //   return null;
    // }
      if (!form) return null;
  if (typeof form === "string") {
    try { return JSON.parse(form); } 
    catch { return null; }
  }
  return form; 
  };


    const QUESTIONNAIRES = {
      phq9: {
        title: 'PHQ-9 Depression Screener',
        subtitle: 'Patient Health Questionnaire',
        instructions: 'Over the last 2 weeks, how often have you been bothered by any of the following problems?',
        questions: [
          'Little interest or pleasure in doing things',
          'Feeling down, depressed, or hopeless',
          'Trouble falling or staying asleep, or sleeping too much',
          'Feeling tired or having little energy',
          'Poor appetite or overeating',
          'Feeling bad about yourself — or that you are a failure or have let yourself or your family down',
          'Trouble concentrating on things, such as reading the newspaper or watching television',
          'Moving or speaking so slowly that other people could have noticed? Or the opposite — being so fidgety or restless that you have been moving around a lot more than usual',
          'Thoughts that you would be better off dead or of hurting yourself in some way'
        ],
        options: [
          { label: 'Not at all', value: 0 },
          { label: 'Several days', value: 1 },
          { label: 'More than half the days', value: 2 },
          { label: 'Nearly every day', value: 3 }
        ],
        extraQuestion: {
          id: 'phq9_extra',
          text: 'If you checked off any problems, how difficult have these problems made it for you to do your work, take care of things at home, or get along with other people?',
          options: [
            { label: 'Not difficult at all', value: 0 },
            { label: 'Somewhat difficult', value: 1 },
            { label: 'Very difficult', value: 2 },
            { label: 'Extremely difficult', value: 3 }
          ]
        },
        score(answers) {
          const total = answers.slice(0, 9).reduce((s, v) => s + (v || 0), 0);
          let level, color, bg;
          if (total <= 4)       { level = 'None – Minimal Depression';     color = '#065f46'; bg = '#ecfdf5'; }
          else if (total <= 9)  { level = 'Mild Depression';               color = '#92400e'; bg = '#fef3c7'; }
          else if (total <= 14) { level = 'Moderate Depression';           color = '#92400e'; bg = '#fef3c7'; }
          else if (total <= 19) { level = 'Moderately Severe Depression';  color = '#991b1b'; bg = '#fee2e2'; }
          else                  { level = 'Severe Depression';             color = '#991b1b'; bg = '#fee2e2'; }
          return { total, level, color, bg,
            text: `Your PHQ-9 score is ${total}/27. Result: ${level}. Your provider will review these results at your appointment.` };
        }
      },

      stopbang: {
        title: 'STOP-BANG Sleep Apnea Screener',
        subtitle: 'Obstructive Sleep Apnea Risk Assessment',
        instructions: 'Please answer Yes or No to each of the following questions.',
        questions: [
          'Snoring — Do you snore loudly (louder than talking or loud enough to be heard through closed doors)?',
          'Tired — Do you often feel tired, fatigued, or sleepy during the daytime?',
          'Observed — Has anyone observed you stop breathing or choking/gasping during your sleep?',
          'Pressure — Do you have or are you being treated for high blood pressure?',
          'BMI — Is your BMI greater than 35?',
          'Age — Are you older than 50 years?',
          'Neck — Is your neck circumference greater than 40 cm (15.7 inches)?',
          'Gender — Are you male?'
        ],
        options: [
          { label: 'Yes', value: 1 },
          { label: 'No',  value: 0 }
        ],
        score(answers) {
          const total = answers.reduce((s, v) => s + (v || 0), 0);
          let level, color, bg;
          if (total <= 2)      { level = 'Low Risk for OSA';          color = '#065f46'; bg = '#ecfdf5'; }
          else if (total <= 4) { level = 'Intermediate Risk for OSA'; color = '#92400e'; bg = '#fef3c7'; }
          else                 { level = 'High Risk for OSA';         color = '#991b1b'; bg = '#fee2e2'; }
          return { total, level, color, bg,
            text: `Your STOP-BANG score is ${total}/8. Result: ${level}. Your provider will review these results at your appointment.` };
        }
      },

      adhd: {
        title: 'ASRS-v1.1 Adult ADHD Self-Report Scale',
        subtitle: 'World Health Organization Screener — Part A',
        instructions: 'Please answer the questions below, rating yourself on each of the criteria shown, using the scale on the right side of the page. As you answer each question, place an X in the box that best describes how you have felt and conducted yourself over the past 6 months.',
        questions: [
          'How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done?',
          'How often do you have difficulty getting things in order when you have to do a task that requires organization?',
          'How often do you have problems remembering appointments or obligations?',
          'When you have a task that requires a lot of thought, how often do you avoid or delay getting started?',
          'How often do you fidget or squirm with your hands or feet when you have to sit down for a long time?',
          'How often do you feel overly active and compelled to do things, like you were driven by a motor?'
        ],
        options: [
          { label: 'Never',     value: 0 },
          { label: 'Rarely',    value: 1 },
          { label: 'Sometimes', value: 2 },
          { label: 'Often',     value: 3 },
          { label: 'Very Often',value: 4 }
        ],
        // ASRS Part A: positives = Sometimes/Often/VeryOften for Q1–3, Often/VeryOften for Q4–6
        score(answers) {
          const thresholds = [2, 2, 2, 3, 3, 3]; // "Sometimes" triggers Q1-3, "Often" triggers Q4-6
          let positives = 0;
          answers.forEach((v, i) => { if ((v || 0) >= thresholds[i]) positives++; });
          const likely = positives >= 4;
          const level = likely ? 'Symptoms Consistent with ADHD' : 'Symptoms Unlikely to Indicate ADHD';
          const color = likely ? '#991b1b' : '#065f46';
          const bg    = likely ? '#fee2e2' : '#ecfdf5';
          return { total: positives, level, color, bg,
            text: `${positives} of 6 responses fell in the shaded zone. Result: ${level}. This is a screener only — your provider will discuss next steps at your appointment.` };
        }
      },

      mdq: {
        title: 'MDQ — Mood Disorder Questionnaire',
        subtitle: 'Bipolar Spectrum Screening Tool',
        instructions: 'Has there ever been a period of time when you were not your usual self and… (check all that apply)',
        questions: [
          '…you felt so good or so hyper that other people thought you were not your normal self or you were so hyper that you got into trouble?',
          '…you were so irritable that you shouted at people or started fights or arguments?',
          '…you felt much more self-confident than usual?',
          '…you got much less sleep than usual and found you didn\'t really miss it?',
          '…you were much more talkative or spoke much faster than usual?',
          '…thoughts raced through your head or you couldn\'t slow your mind down?',
          '…you were so easily distracted by things around you that you had trouble concentrating or staying on track?',
          '…you had much more energy than usual?',
          '…you were much more active or did many more things than usual?',
          '…you were much more social or outgoing than usual (e.g., telephoned friends in the middle of the night)?',
          '…you were much more interested in sex than usual?',
          '…you did things that were unusual for you or that other people might have seen as excessive, foolish, or risky?',
          '…spending money got you or your family into trouble?'
        ],
        options: [
          { label: 'Yes', value: 1 },
          { label: 'No',  value: 0 }
        ],
        extraQuestions: [
          {
            id: 'mdq_same_time',
            text: 'If you checked YES to more than one of the above, have several of these ever happened during the same period of time?',
            options: [
              { label: 'Yes', value: 1 },
              { label: 'No',  value: 0 }
            ]
          },
          {
            id: 'mdq_problem',
            text: 'How much of a problem did any of these cause you — like being unable to work; having family, money, or legal troubles; or getting into arguments or fights?',
            options: [
              { label: 'No problem',         value: 0 },
              { label: 'Minor problem',      value: 1 },
              { label: 'Moderate problem',   value: 2 },
              { label: 'Serious problem',    value: 3 }
            ]
          }
        ],
        score(answers, extra) {
          const yesCount = answers.slice(0, 13).reduce((s, v) => s + (v || 0), 0);
          const sameTime = (extra && extra.mdq_same_time) ? extra.mdq_same_time : 0;
          const problem  = (extra && extra.mdq_problem)   ? extra.mdq_problem   : 0;
          const positive = yesCount >= 7 && sameTime === 1 && problem >= 2;
          const level = positive ? 'Positive Screen — Possible Bipolar Disorder' : 'Screen Negative';
          const color = positive ? '#991b1b' : '#065f46';
          const bg    = positive ? '#fee2e2' : '#ecfdf5';
          return { total: yesCount, level, color, bg,
            text: `You endorsed ${yesCount} of 13 symptom items. Result: ${level}. This is a clinical screener — your provider will review results and discuss further at your appointment.` };
        }
      }
    };

  const forms = {
    form_1: parseForm(data?.form_1),
    form_2: parseForm(data?.form_2),
    form_3: parseForm(data?.form_3),
    form_4: parseForm(data?.form_4),
    form_5: parseForm(data?.form_5),
    form_6: parseForm(data?.form_6),
    form_7: parseForm(data?.form_7),
    form_8: parseForm(data?.form_8),
    form_9: parseForm(data?.form_9),
    form_10: parseForm(data?.form_10),
    form_11: parseForm(data?.form_11),
    form_12: parseForm(data?.form_12),
    form_13: parseForm(data?.form_13),
    phq9: parseForm(data?.phq9),
    stopbang: parseForm(data?.stopbang),
    adhd: parseForm(data?.adhd),
    mdq: parseForm(data?.mdq),
  };
  const tertiaryDOB = forms.form_2?.tertiarydob;
  const displayDOB =
    !tertiaryDOB || tertiaryDOB === "Invalid date" ? "-" : tertiaryDOB;
  const secondaryDOB = forms.form_2?.secondarydob;
  const displaySecondaryDOB =
    !secondaryDOB || secondaryDOB === "Invalid date" ? "-" : secondaryDOB;
  const primaryDOB = forms.form_2?.primarydob;
  const displayPrimaryDOB =
    !primaryDOB || primaryDOB === "Invalid date" ? "-" : primaryDOB;
  // const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  function renderAgeField(dob) {
    if (!dob) return null;
    const birthDate = dayjs(dob);
    const today = dayjs();
    return today.diff(birthDate, "year");
  }

  const capitalize = (v) =>
    typeof v === "string" && v.length > 0
      ? v.charAt(0).toUpperCase() + v.slice(1)
      : v ?? "—";

const formatValue = (val) => {
  // 🟢 If it's JSX (a React element), return it directly
  if (typeof val === "object" && !Array.isArray(val) && val !== null && val.$$typeof) {
    return val;
  }

  if (Array.isArray(val)) {
    if (val.length === 0) return "—";
    return val
      .map((item) =>
        typeof item === "string"
          ? item.charAt(0).toUpperCase() + item.slice(1)
          : item
      )
      .join(", ");
  }

  if (val === null || val === undefined || val === "") {
    return "—";
  }

  if (typeof val === "string") {
    return val.charAt(0).toUpperCase() + val.slice(1);
  }

  return String(val);
};


  const renderField = (label, value) => (
    <p>
      <div>{label}:</div>{" "}
      {Array.isArray(value) ? (
        formatValue(value)
      ) : (
        <div className="font-medium">{formatValue(value)}</div>
      )}
    </p>
  );

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white max-w-6xl w-full text-start max-h-[90vh] rounded-lg relative flex flex-col">
        <button
          onClick={() => setIsModal(false)}
          className="absolute top-4 right-4 text-2xl text-gray-600 hover:text-black"
        >
          <IoClose />
        </button>

        <div className="p-6 border-b text-xl font-semibold">View Document</div>

        <div className="overflow-y-auto px-6 py-4 space-y-8 text-sm text-gray-800">
          <Accordion title="Patient Details">
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
              {renderField("First Name", forms.form_1?.firstname)}
              {renderField("Last Name", forms.form_1?.lastname)}
              {renderField("Phone", forms.form_1?.phone)}
              {renderField("Home Phone", forms.form_1?.homephone)}
              {renderField("Date of Birth", forms.form_1?.dob)}
              {renderField(
                "Age",
                forms.form_1?.dob && renderAgeField(forms.form_1.dob)
              )}
              {renderField("Sex", forms.form_1?.gender)}
              {renderField("Gender Identity", forms.form_1?.genderIdentity)}
              {renderField("Address", forms.form_1?.address)}
              {renderField("Zip Code", forms.form_1?.zipcode)}
              {renderField("Marital Status", forms.form_1?.maritalstatus)}
              {renderField("SSE", forms.form_1?.sse)}
              {renderField("Spouse Name", forms.form_1?.spousename)}
              {renderField("Spouse Phone", forms.form_1?.spousephone)}
              {renderField("Spouse Home Phone", forms.form_1?.spousehomephone)}
              {renderField("Spouse Address", forms.form_1?.spouseaddress)}
              {renderField("Spouse Zip Code", forms.form_1?.spousezipcode)}
              {renderField("Emergency Contact", forms.form_1?.emergencycontact)}
              {renderField("Emergency Phone", forms.form_1?.emergencyphone)}
              {renderField("Relationship", forms.form_1?.relationship)}
              {renderField("Referred By", forms.form_1?.referrredby)}
              {data?.profile && (
                <img
                  className="w-[120px] h-[130px]"
                  src={`/onboarding/profile_pics/${data.profile}`}
                  alt="Profile"
                  onError={(e) => {
                    e.target.onerror = null; // Prevent infinite loop
                    e.target.src = `/chimlw/onboarding_forms/create/profile/${data.profile}`;
                  }}
                />
              )}
            </div>
          </Accordion>

          <Accordion title="Insurance Details">
              {forms.form_2?.paymentMethod?.toLowerCase() === "selfpay" ? (
              <div className="p-4 bg-green-50 border border-green-200 rounded-md text-green-800">
                <p className="font-semibold">✅ Self Pay Selected</p>
                <p className="mt-2">
                  No insurance information is required. Our team will discuss payment
                  options and pricing with you at your visit. You can always update
                  this later by contacting our office.
                </p>
              </div>
            ) : (
              <>
            {/* Text Fields */}
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
              {renderField("Primary Insurance", forms.form_2?.primaryinsurance)}
              {renderField(
                "Primary Subscriber Name",
                forms.form_2?.primarysubscribername
              )}
              {renderField("Primary DOB", displayPrimaryDOB)}
              {renderField("Primary SSN", forms.form_2?.primaryssn)}
              {renderField(
                "Primary Relationship",
                forms.form_2?.primaryrelationship
              )}
              {renderField("Subscriber ID", forms.form_2?.subscriberid)}
              {renderField("Group ID", forms.form_2?.groupid)}
              {renderField(
                "Secondary Insurance",
                forms.form_2?.secondaryinsurance
              )}
              {renderField(
                "Secondary Subscriber Name",
                forms.form_2?.secondarysubscribername
              )}
              {renderField("Secondary DOB", displaySecondaryDOB)}
              {renderField("Secondary SSN", forms.form_2?.secondaryssn)}
              {renderField(
                "Secondary Relationship",
                forms.form_2?.secondaryrelationship
              )}
              {renderField(
                "Secondary Subscriber ID",
                forms.form_2?.secondarysubscriberid
              )}
              {renderField(
                "Secondary Group ID",
                forms.form_2?.secondarygroupid
              )}
              {renderField(
                "Tertiary Insurance",
                forms.form_2?.tertiaryinsurance
              )}
              {renderField(
                "Tertiary Subscriber Name",
                forms.form_2?.tertiarysubscribername
              )}
              {renderField("Tertiary DOB", displayDOB)}
              {renderField("Tertiary SSN", forms.form_2?.tertiaryssn)}
              {renderField(
                "Tertiary Relationship",
                forms.form_2?.tertiaryrelationship
              )}
              {renderField(
                "Tertiary Subscriber ID",
                forms.form_2?.tertiarysubscriberid
              )}
              {renderField("Tertiary Group ID", forms.form_2?.tertiarygroupid)}
              {renderField(
                "Worker Compensation",
                forms.form_2?.workercompensation
              )}
              {renderField("Auto Accident", forms.form_2?.autoaccident)}
            </div>

            {data?.images?.length > 0 && (
              <div className="mt-6 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {data.images
                  .filter(
                    (img) =>
                      img.type === "INSURANCE" &&
                      (img.fornt_image || img.back_image_path) // skip card if both missing
                  )
                  .map((img, index) => (
                    <div
                      key={index}
                      className="border p-3 rounded shadow-sm flex flex-col gap-4 w-full"
                    >
                      {/* Front Image */}
                      {img.fornt_image && (
                        <div className="flex flex-col gap-2">
                          <p className="text-sm text-gray-600 mb-1">
                            Front Image
                          </p>
                          <div className="w-full h-64 flex justify-center items-center border">
                            <img
                              src={`/onboarding/images/${img.fornt_image}`}
                              alt={`Insurance Front ${index}`}
                              className="max-w-full max-h-full object-contain"
                              onClick={() => setBigImage(img.fornt_image)}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = `/chimlw/onboarding_forms/uploadImages/images/${img.fornt_image}`;
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {/* Back Image */}
                      {img.back_image_path && (
                        <div className="flex flex-col gap-2">
                          <p className="text-sm text-gray-600 mb-1">
                            Back Image
                          </p>
                          <div className="w-full h-64 flex justify-center items-center border">
                            <img
                              src={`/onboarding/images/${img.back_image_path}`}
                              alt={`Insurance Back ${index}`}
                              className="max-w-full max-h-full object-contain"
                              onClick={() => setBigImage(img.back_image_path)}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = `/chimlw/onboarding_forms/uploadImages/images/${img.back_image_path}`;
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            )}
          </>
        )}
      </Accordion>


          <Accordion title="Medical History">
            {/* Medications Table */}
            <div className="mt-2">
              <h6 className="font-semibold mb-2">Medications</h6>
              <table className="min-w-full border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-2 py-1 text-left">Medication</th>
                    <th className="border px-2 py-1 text-left">Dose (mg)</th>
                    <th className="border px-2 py-1 text-left">
                      Times Per Day
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {forms.form_3?.medications?.map((med, idx) => (
                    <tr key={idx}>
                      <td className="border px-2 py-1">
                        {capitalize(med.medication)}
                        {/* {typeof med.medication === "string"
                          ? med.medication.charAt(0).toUpperCase() +
                            med.medication.slice(1)
                          : med.medication ?? "—"} */}
                      </td>

                      <td className="border px-2 py-1">
                        {capitalize(med.dose)}
                        {/* {typeof med.dose === "string"
                          ? med.dose.charAt(0).toUpperCase() + med.dose.slice(1)
                          : med.dose ?? "—"} */}
                      </td>

                      <td className="border px-2 py-1">
                        {capitalize(med.timesPerDay)}
                        {/* {typeof med.timesPerDay === "string"
                          ? med.timesPerDay.charAt(0).toUpperCase() +
                            med.timesPerDay.slice(1)
                          : med.timesPerDay ?? "—"} */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Surgical History Table */}
            <div className="mt-4">
              <h6 className="font-semibold mb-2">Surgical History</h6>
              <table className="min-w-full border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-2 py-1 text-left">Operation</th>
                    <th className="border px-2 py-1 text-left">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {forms.form_3?.surgicalHistory?.map((surg, idx) => (
                    <tr key={idx}>
                      <td className="border px-2 py-1">
                        {capitalize(surg.operation)}
                      </td>
                      <td className="border px-2 py-1">
                        {capitalize(surg.date)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Allergies Table */}
            <div className="mt-4">
              <h6 className="font-semibold mb-2">Allergies</h6>
              <table className="min-w-full border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-2 py-1 text-left">Agent</th>
                    <th className="border px-2 py-1 text-left">Reaction</th>
                  </tr>
                </thead>
                <tbody>
                  {forms.form_3?.allergies?.map((allergy, idx) => (
                    <tr key={idx}>
                      <td className="border px-2 py-1">
                        {capitalize(allergy.agent)}
                      </td>
                      <td className="border px-2 py-1">
                        {capitalize(allergy.reaction)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Other Fields Below Tables */}
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {renderField(
                "No Family History",
                forms.form_3?.noFamilyHistory ? "Yes" : "No"
              )}
              {renderField(
                "Medical History",
                forms.form_3?.medicalHistory?.length > 0 ? (
                  <ul className="list-disc text-start p-4">
                    {forms.form_3.medicalHistory.map((item, index) => (
                      <li key={index}>{capitalize(item)}</li>
                    ))}
                  </ul>
                ) : (
                  "N/A"
                )
              )}

              {renderField(
                "Other Problem Details",
                forms.form_3?.otherProblemDetails
              )}
              {renderField(
                "Serious Conditions",
                <ul className="list-disc pl-4">
                  {forms.form_3?.seriousConditions && (
                    <>
                      {forms.form_3.seriousConditions.cancerYear && (
                        <li>
                          Cancer: {forms.form_3.seriousConditions.cancerYear}
                        </li>
                      )}
                      {forms.form_3.seriousConditions.heartAttackYear && (
                        <li>
                          Heart Attack:{" "}
                          {forms.form_3.seriousConditions.heartAttackYear}
                        </li>
                      )}
                      {forms.form_3.seriousConditions.bloodTransfusionYear && (
                        <li>
                          Blood Transfusion:{" "}
                          {forms.form_3.seriousConditions.bloodTransfusionYear}
                        </li>
                      )}
                      {forms.form_3.seriousConditions.strokeYear && (
                        <li>
                          Stroke: {forms.form_3.seriousConditions.strokeYear}
                        </li>
                      )}
                      {forms.form_3.seriousConditions.seizureYear && (
                        <li>
                          Seizure: {forms.form_3.seriousConditions.seizureYear}
                        </li>
                      )}
                    </>
                  )}
                </ul>
              )}
              {renderField(
                "Health Concerns",
                forms.form_3?.healthConcerns?.length > 0 ? (
                  <ul className="list-disc pl-4">
                    {forms.form_3.healthConcerns.map((concern, index) => (
                      <li key={index}>{capitalize(concern)}</li>
                    ))}
                  </ul>
                ) : (
                  "N/A"
                )
              )}
              {data?.images?.length > 0 && (
                <div className="mt-6 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                  {data.images
                    .filter(
                      (img) => img.type === "MEDICATION" && img.fornt_image // skip card if both missing
                    )
                    .map((img, index) => (
                      <div
                        key={index}
                        className="border p-3 rounded shadow-sm flex flex-col gap-4 w-full"
                      >
                        {/* Front Image */}
                        {img.fornt_image && (
                          <div className="flex flex-col gap-2">
                            <div className="w-full h-64 flex justify-center items-center border">
                              <img
                                src={`/onboarding/images/${img.fornt_image}`}
                                alt={`Insurance Front ${index}`}
                                className="max-w-full max-h-full object-contain"
                                onClick={() => setBigImage(img.fornt_image)}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = `/chimlw/onboarding_forms/uploadImages/images/${img.fornt_image}`;
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </Accordion>

          <Accordion title="Family History">
            <div className="">
              {/* Show "I do not know my family history" */}
              {renderField(
                "Unknown Family History",
                forms.form_4?.noFamilyHistory ? "Yes" : "No"
              )}

              {/* Only show table if family history is known */}
              {!forms.form_4?.noFamilyHistory &&
                forms.form_4?.familyHistory && (
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse mt-2 text-sm text-gray-800">
                      <thead>
                        <tr>
                          <th className="border border-gray-200 p-2.5 text-start bg-gray-100 font-semibold">
                            Medical Condition
                          </th>
                          <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold">
                            Mom
                          </th>
                          <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold">
                            Dad
                          </th>
                          <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold">
                            Brother
                          </th>
                          <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold">
                            Sister
                          </th>
                          <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold">
                            Grandmother
                          </th>
                          <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold">
                            Grandfather
                          </th>
                          <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold">
                            Son
                          </th>
                          <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold">
                            Daughter
                          </th>
                          <th className="border border-gray-200 p-2.5 text-center bg-gray-100 font-semibold">
                            Other
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          "Alcoholism",
                          "Anemia",
                          "Hay Fever",
                          "Asthma",
                          "Arthritis",
                          "High Blood Pressure",
                          "Coronary Artery Disease",
                          "High Cholesterol",
                          "Cancer, Breast",
                          "Cancer, Colon",
                          "Cancer, Ovary",
                          "Cancer, Prostate",
                          "Migraine Headaches",
                          "Osteoporosis",
                          "Diabetes",
                          "Depression",
                          "Thyroid Disorders",
                          "Stroke",
                          "Seizures",
                        ].map((condition) => {
                          const keyBase = condition
                            .toLowerCase()
                            .replace(/, /g, "")
                            .replace(/ /g, "");
                          const family = forms.form_4.familyHistory;
                          return (
                            <tr key={condition}>
                              <td className="border border-gray-200 p-2.5 bg-white font-semibold text-start">
                                {condition}
                              </td>
                              {[
                                "Mom",
                                "Dad",
                                "Brother",
                                "Sister",
                                "GM",
                                "GF",
                                "Son",
                                "Daughter",
                                "Other",
                              ].map((rel) => (
                                <td
                                  key={rel}
                                  className="border border-gray-200 p-2.5 bg-white text-center"
                                >
                                  {family[`${keyBase}${rel}`] ? "✓" : ""}
                                </td>
                              ))}
                            </tr>
                          );
                        })}
                        {/* Show otherFamilyHistory text */}
                        {forms.form_4?.familyHistory.otherFamilyHistory && (
                          <tr>
                            <td className="border border-gray-200 p-2.5 bg-white font-semibold text-start">
                              Other:
                            </td>
                            <td
                              colSpan={9}
                              className="border border-gray-200 p-2.5 bg-white text-start"
                            >
                              {forms.form_4.familyHistory.otherFamilyHistory}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
            </div>
          </Accordion>

          {/* Repeat the Accordion structure for form_5 to form_13 similarly */}
          {/* Example for form_5 */}
          {forms.form_5 && (
            <Accordion title="Social History">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {forms.form_5?.tobaccoUse &&
                  renderField("Tobacco Use", forms.form_5.tobaccoUse)}
                {forms.form_5.tobaccoQuestions &&
                  Object.entries(forms.form_5.tobaccoQuestions).map(
                    ([key, value]) => {
                      if (!value) return null;
                      const label = key.replace(/([A-Z])/g, " $1").trim();
                      const capitalizedLabel =
                        label.charAt(0).toUpperCase() + label.slice(1);
                      return renderField(capitalizedLabel, value);
                    }
                  )}

                {forms.form_5?.alcoholUse &&
                  renderField("Alcohol Use", forms.form_5.alcoholUse)}
                {forms.form_5?.alcoholQuestions &&
                  Object.entries(forms.form_5.alcoholQuestions).map(
                    ([key, value]) => {
                      if (!value) return null;
                      const label = key.replace(/([A-Z])/g, " $1").trim();
                      const capitalizedLabel =
                        label.charAt(0).toUpperCase() + label.slice(1);
                      return renderField(capitalizedLabel, value);
                    }
                  )}

                {forms.form_5?.recreationalDrugs &&
                  renderField(
                    "Recreational Drugs",
                    forms.form_5.recreationalDrugs
                  )}
                {forms.form_5?.drugQuestions &&
                  Object.entries(forms.form_5.drugQuestions).map(
                    ([key, value]) => {
                      if (!value) return null;
                      const label = key.replace(/([A-Z])/g, " $1").trim();
                      const capitalizedLabel =
                        label.charAt(0).toUpperCase() + label.slice(1);
                      return renderField(capitalizedLabel, value);
                    }
                  )}

                {forms.form_5?.sexualActive &&
                  renderField("Sexually Active", forms.form_5.sexualActive)}
                {forms.form_5.sexualityQuestions &&
                  Object.entries(forms.form_5.sexualityQuestions).map(
                    ([key, value]) => {
                      if (!value) return null;
                      const label = key.replace(/([A-Z])/g, " $1").trim();
                      const capitalizedLabel =
                        label.charAt(0).toUpperCase() + label.slice(1);
                      return renderField(capitalizedLabel, value);
                    }
                  )}

                {forms.form_5?.ethnicBackground &&
                  renderField(
                    "Ethnic Background",
                    forms.form_5.ethnicBackground
                  )}
                {forms.form_5?.numberChildren &&
                  renderField(
                    "Number of Children",
                    forms.form_5.numberChildren
                  )}
                {forms.form_5?.whoLiveWithYou &&
                  renderField(
                    "Who Lives With You",
                    forms.form_5.whoLiveWithYou
                  )}
                {forms.form_5?.occupation &&
                  renderField("Occupation", forms.form_5.occupation)}
                {forms.form_5.education &&
                  renderField("Education", forms.form_5.education)}
                {forms.form_5?.botheredByProblems &&
                  renderField(
                    "Bothered By Problems (0-5)",
                    forms.form_5?.botheredByProblems
                  )}
                {forms.form_5?.littlePleasure &&
                  renderField(
                    "Little Pleasure (0-5)",
                    forms.form_5.littlePleasure
                  )}
              </div>
            </Accordion>
          )}
          {forms.form_6 && (
            <Accordion title="Care Team">
              <div className="grid grid-cols-1 gap-4">
                {/* Home Health Company */}
                {forms.form_6.homeHealthCompany &&
                  renderField(
                    "Home Health Company",
                    forms.form_6.homeHealthCompany
                  )}

                {/* Care Team Table */}
                {forms.form_6.careTeam?.length > 0 && (
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse mt-2 text-sm text-gray-800">
                      <thead>
                        <tr>
                          <th className="border border-gray-200 p-2.5 text-start bg-gray-100 font-semibold">
                            Specialty
                          </th>
                          <th className="border border-gray-200 p-2.5 text-start bg-gray-100 font-semibold">
                            Doctor Name
                          </th>
                          <th className="border border-gray-200 p-2.5 text-start bg-gray-100 font-semibold">
                            Phone
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {forms.form_6?.careTeam.map((member, index) => (
                          <tr key={index}>
                            <td className="border border-gray-200 p-2.5 bg-white">
                              {member.specialty}
                            </td>
                            <td className="border border-gray-200 p-2.5 bg-white">
                              {member.doctorName}
                            </td>
                            <td className="border border-gray-200 p-2.5 bg-white">
                              {member.phone}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </Accordion>
          )}
          {forms.form_7 && (
            <Accordion title="Review of Systems">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Loop through each system */}
                {forms.form_7?.reviewOfSystems &&
                  Object.entries(forms.form_7.reviewOfSystems).map(
                    ([system, items]) => {
                      if (!items?.length) return null;
                      const systemLabel = system.replace(/_/g, " ").trim();
                      const capitalizedLabel =
                        systemLabel.charAt(0).toUpperCase() +
                        systemLabel.slice(1);
                      return (
                        <div key={system}>
                          <h6 className="font-semibold text-gray-700 mb-1">
                            {capitalizedLabel}
                          </h6>
                          <ul className="list-disc list-inside text-gray-800 text-sm">
                            {items.map((item, index) => (
                              <li key={index}>{capitalize(item)}</li>
                            ))}
                          </ul>
                        </div>
                      );
                    }
                  )}

                {/* Show "Other" if available */}
                {forms.form_7?.rosOther && (
                  <div>
                    <h6 className="font-semibold text-gray-700 mb-1">Other</h6>
                    <p className="text-gray-800 text-sm">
                      {forms?.form_7.rosOther}
                    </p>
                  </div>
                )}
              </div>
            </Accordion>
          )}
          {forms.form_8 && (
            <Accordion title="Immunizations">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {forms.form_8?.immunizations &&
                  Object.entries(forms.form_8?.immunizations).map(
                    ([vaccine, data]) => {
                      // Skip "otherVaccineDetails" since we'll show it separately
                      if (vaccine === "otherVaccineDetails") return null;

                      return (
                        <div key={vaccine} className="flex gap-2 items-center">
                          <span className="font-semibold text-gray-700">
                            {vaccine
                              .replace(/([A-Z])/g, " $1")
                              .replace(/^./, (c) => c.toUpperCase())}
                            :
                          </span>
                          <span className="text-gray-800 text-sm">
                            {data.received ? "Received" : "Not Received"}
                            {data.date ? ` (Date: ${data.date})` : ""}
                          </span>
                        </div>
                      );
                    }
                  )}

                {/* Other Vaccine Details */}
                {forms.form_8.immunizations?.otherVaccineDetails && (
                  <div className="flex gap-2 items-center">
                    <span className="font-semibold text-gray-700">
                      Other Vaccine:
                    </span>
                    <span className="text-gray-800 text-sm">
                      {forms.form_8.immunizations?.otherVaccineDetails}
                    </span>
                  </div>
                )}

                {/* Flu Tolerance */}
                {forms.form_8?.fluTolerance &&
                  renderField("Flu Tolerance", forms.form_8?.fluTolerance)}
                {data?.images?.length > 0 && (
                  <div className="mt-6 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    {data.images
                      .filter(
                        (img) => img.type === "VACCINATION" && img.fornt_image // skip card if both missing
                      )
                      .map((img, index) => (
                        <div
                          key={index}
                          className="border p-3 rounded shadow-sm flex flex-col gap-4 w-full"
                        >
                          {/* Front Image */}
                          {img.fornt_image && (
                            <div className="flex flex-col gap-2">
                              <div className="w-full h-64 flex justify-center items-center border">
                                <img
                                  src={`/onboarding/images/${img.fornt_image}`}
                                  alt={`Insurance Front ${index}`}
                                  className="max-w-full max-h-full object-contain"
                                  onClick={() => setBigImage(img.fornt_image)}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = `/chimlw/onboarding_forms/uploadImages/images/${img.fornt_image}`;
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </Accordion>
          )}
          {forms.form_9 && (
            <Accordion title="Consent Form">
              <div className="grid grid-cols-1 gap-4">
                {[
                  {
                    id: "privacyConsent",
                    label:
                      "I acknowledge that I have read and understand the HIPAA Privacy Notice and agree to the use and disclosure of my health information as described.",
                  },
                  {
                    id: "aiScribeConsent",
                    label:
                      "I understand and consent to the use of AI scribes and automated documentation systems during my healthcare encounters at Center for Hypertension.",
                  },
                  {
                    id: "electronicConsent",
                    label:
                      "I consent to electronic communication and understand the risks associated with electronic transmission of health information.",
                  },
                  {
                    id: "accuracyConsent",
                    label:
                      "I certify that all information provided in this registration form is accurate and complete to the best of my knowledge.",
                  },
                  {
                    id: "treatmentConsent",
                    label:
                      "I consent to treatment and authorize Center for Hypertension to provide medical care and services.",
                  },
                ].map((consent) =>
                  forms.form_9[consent.id] ? (
                    <div
                      key={consent.id}
                      className="flex items-start gap-2 text-sm"
                    >
                      <span className="text-green-600 font-semibold">✓</span>
                      <span className="text-gray-800">{consent.label}</span>
                    </div>
                  ) : null
                )}
              </div>
            </Accordion>
          )}









{['phq9', 'stopbang', 'adhd', 'mdq'].map((key) => {
  const formData = forms[key];

  if (!formData) return null;

  // -----------------------------
  // Convert Answer Label -> Value
  // -----------------------------
  const getOptionValue = (options, answer) => {
    const found = options.find(
      (o) =>
        o.label.toLowerCase().trim() ===
        String(answer || "").toLowerCase().trim()
    );

    return found ? found.value : 0;
  };

  let answers = [];
  let extra = {};
  let result = null;

  // -----------------------------
  // PHQ9
  // -----------------------------
  if (key === "phq9") {
    answers = Array.from({ length: 9 }, (_, i) =>
      getOptionValue(
        QUESTIONNAIRES.phq9.options,
        formData[`qanswer_phq9_${i + 1}`]
      )
    );

    extra = {
      phq9_extra: getOptionValue(
        QUESTIONNAIRES.phq9.extraQuestion.options,
        formData["qanswer_phq9_10"]
      ),
    };

    result = QUESTIONNAIRES.phq9.score(answers, extra);
  }

  // -----------------------------
  // STOPBANG
  // -----------------------------
  if (key === "stopbang") {
    answers = Array.from({ length: 8 }, (_, i) =>
      getOptionValue(
        QUESTIONNAIRES.stopbang.options,
        formData[`qanswer_stopbang_${i + 1}`]
      )
    );

    result = QUESTIONNAIRES.stopbang.score(answers);
  }

  // -----------------------------
  // ADHD
  // -----------------------------
  if (key === "adhd") {
    answers = Array.from({ length: 6 }, (_, i) =>
      getOptionValue(
        QUESTIONNAIRES.adhd.options,
        formData[`qanswer_adhd_${i + 1}`]
      )
    );

    result = QUESTIONNAIRES.adhd.score(answers);
  }

  // -----------------------------
  // MDQ
  // -----------------------------
  if (key === "mdq") {
    answers = Array.from({ length: 13 }, (_, i) =>
      getOptionValue(
        QUESTIONNAIRES.mdq.options,
        formData[`qanswer_mdq_${i + 1}`]
      )
    );

    extra = {
      mdq_same_time: getOptionValue(
        QUESTIONNAIRES.mdq.extraQuestions[0].options,
        formData["mdq_same_time"]
      ),

      mdq_problem: getOptionValue(
        QUESTIONNAIRES.mdq.extraQuestions[1].options,
        formData["mdq_problem"]
      ),
    };

    result = QUESTIONNAIRES.mdq.score(answers, extra);
  }

  return (
    <Accordion key={key} title={QUESTIONNAIRES[key].title}>
      <div className="grid grid-cols-1 gap-4">

        {/* QUESTIONS */}
        {QUESTIONNAIRES[key].questions.map((q, idx) => {
          const answerKey = `qanswer_${key}_${idx + 1}`;
          const answer = formData[answerKey];

          return answer ? (
            <div key={answerKey} className="flex items-start gap-2 text-sm">
              <span className="text-green-600 font-semibold">✓</span>

              <span className="text-gray-800">
                {q} — {answer}
              </span>
            </div>
          ) : null;
        })}

        {/* PHQ9 EXTRA */}
        {key === "phq9" &&
          formData["qanswer_phq9_10"] && (
            <div className="flex items-start gap-2 text-sm mt-2">
              <span className="text-green-600 font-semibold">✓</span>

              <span className="text-gray-800">
                {QUESTIONNAIRES.phq9.extraQuestion.text} —{" "}
                {formData["qanswer_phq9_10"]}
              </span>
            </div>
          )}

        {/* MDQ EXTRA */}
        {key === "mdq" &&
          QUESTIONNAIRES.mdq.extraQuestions.map((extraQ) => {
            const answer = formData[extraQ.id];

            return answer ? (
              <div
                key={extraQ.id}
                className="flex items-start gap-2 text-sm mt-2"
              >
                <span className="text-green-600 font-semibold">✓</span>

                <span className="text-gray-800">
                  {extraQ.text} — {answer}
                </span>
              </div>
            ) : null;
          })}

        {/* SCORE CARD */}
        {result && (
          <div
            className="mt-6 rounded-xl border p-5"
            style={{
              background: result.bg,
              borderColor: result.color,
            }}
          >
            <div className="flex justify-between items-center flex-wrap gap-4">

              {/* LEFT SIDE */}
              <div>
                <h3
                  className="text-lg font-bold"
                  style={{
                    color: result.color,
                  }}
                >
                  {result.level}
                </h3>

                <p className="text-sm mt-2 text-gray-700">
                  {result.text}
                </p>
              </div>

              {/* SCORE CIRCLE */}
              <div
                className="w-20 h-20 rounded-full border-4 flex items-center justify-center text-2xl font-bold bg-white"
                style={{
                  borderColor: result.color,
                  color: result.color,
                }}
              >
                {result.total}
              </div>
            </div>
          </div>
        )}
      </div>
    </Accordion>
  );
})}





          {data?.document_file && (
            <div className="mt-4">
              <h2 className="text-lg font-semibold mb-2 text-blue-700">
                Uploaded Document
              </h2>
              <button
                className="flex items-center gap-2 text-blue-600 hover:underline"
                onClick={() =>
                  window.open(
                    `/chimlw/onboarding_forms/create/document/${data.document_file}`,
                    "_blank"
                  )
                }
              >
                <FontAwesomeIcon icon={faFile} />
                <span>View PDF</span>
              </button>
            </div>
          )}

          <div className="flex justify-center">
            <PDFDownloadLink
              document={<OnboardPDF data={data} forms={forms} />}
              fileName={`Onboarding-${
                forms.form_1?.firstname || "Document"
              }.pdf`}
            >
              {({ loading }) => (
                <button className="bg-[#E17954] text-white px-4 py-1 rounded-md">
                  {loading ? "Preparing PDF..." : "Print"}
                </button>
              )}
            </PDFDownloadLink>
          </div>
        </div>
      </div>
      {bigImage && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-4 relative max-w-[95vw] max-h-[95vh] shadow-lg">
            <button
              className="absolute top-2 right-2 text-gray-700 text-3xl"
              onClick={() => setBigImage(null)}
            >
              <IoClose />
            </button>

            <img
              src={`/onboarding/images/${bigImage}`}
              alt="Big Preview"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `/chimlw/onboarding_forms/uploadImages/images/${bigImage}`;
              }}
              className="max-w-full max-h-[80vh] object-contain"
            />
          </div>
        </div>
      )}

      <Backdrop
        sx={{
          color: "secondary.main",
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>
    </div>
  );
};

export default OnBoardView;
